module.exports = (__webpack_require__(20711))(2560);